/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import { createSlice } from '@reduxjs/toolkit';
import { GetFirstSystemConfig, GetTolerances, PartialUpdateSystemConfig } from "./SystemConfigApi";
import { ResponseApi } from "../BaseApi";

/**
 * SystemConfigSlice
 *
 * This Redux slice is responsible for handling state related to system configuration.
 * It stores the result of fetching and updating the system configuration via async actions.
 */

const SystemConfigSlice = createSlice({
    name: 'systemConfig', // Name of the slice
    initialState: {
        getFirstSystemConfig: null,         // Stores the system config data fetched from the API
        tolerances: null,                   // Stores the access tolerance config fetched from the API
        partialUpdateSystemConfig: null,    // Stores the result of updating the system config
    },
    reducers: {
        // No synchronous reducers are defined for this slice
    },
    extraReducers: builder => {
        // Handles fulfilled state for GetFirstSystemConfig async action
        builder.addCase(GetFirstSystemConfig.fulfilled, (state, action) => {
            state.getFirstSystemConfig = ResponseApi(action.payload); // Process and store the API response
        });

        // Handles fulfilled state for GetTolerances async action
        builder.addCase(GetTolerances.fulfilled, (state, action) => {
            state.tolerances = ResponseApi(action.payload); // Process and store the API response
        });

        // Handles fulfilled state for PartialUpdateSystemConfig async action
        builder.addCase(PartialUpdateSystemConfig.fulfilled, (state, action) => {
            state.partialUpdateSystemConfig = ResponseApi(action.payload); // Process and store the API response
        });
    },
});

// No synchronous actions to export
export const {} = SystemConfigSlice.actions;

// Export the reducer to be added to the Redux store
export default SystemConfigSlice.reducer;
